import { render, staticRenderFns } from "./CustomerEditFormWizard.vue?vue&type=template&id=728ab378&"
import script from "./CustomerEditFormWizard.vue?vue&type=script&lang=ts&"
export * from "./CustomerEditFormWizard.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerEditFormWizard.vue?vue&type=style&index=0&id=728ab378&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports